export const AD_IMPRESSION_THRESHOLD = 0.9

export const TOTAL_AD_SLOTS = 4
export const TOTAL_ACTIVITY_AD_SLOTS = 12
